export default __webpack_public_path__ + "static/media/fondo.e067abb7.png";